import { Badge } from '../ui/badge';
import { statusLabel } from '../../lib/supportConstants';

const STATUS_STYLES = {
  open: 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300',
  in_progress: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300',
  waiting_customer: 'bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-300',
  resolved: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  closed: 'bg-slate-200 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
};

export default function TicketStatusBadge({ status, className = '' }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.open;
  return (
    <Badge variant="secondary" className={`font-normal text-[11px] ${style} ${className}`}>
      {statusLabel(status)}
    </Badge>
  );
}
